export default {
  namespaced: true,

  state: {
    isEditMode: false,
  },

  getters: {
    isEditMode: (state) => state.isEditMode,
  },

  mutations: {
    SET_EDIT_MODE(state, value) {
      state.isEditMode = !!value;
    },
  },

  actions: {
    enableEditMode({ commit }) {
      commit('SET_EDIT_MODE', true);
    },

    disableEditMode({ commit }) {
      commit('SET_EDIT_MODE', false);
    },
  },
};